
/* Used to pass data into component */
const DataBus = {
  haveData : false, 
  haveUserSettings: false,
  config : {}, 
  data : {},
  userSettings: {}, 
  dataEvents : {
    // holder for callback in Index component 
  },	
  setData: (dcConfig, dcData) => {
    // * SheetData callback 
    //console.log( dcData);
    DataBus.haveData = true;		
    DataBus.config = dcConfig; 
    DataBus.data = dcData; 

    if (DataBus.dataEvents.setDCData) { 
      // if the callback exists, load the data into the page component
      // (race whether Index loads before the data)
      //console.log("DataBus.dataEvents.setDCData");
      DataBus.dataEvents.setDCData(dcConfig, dcData);
    } else {
      //console.log('no callback yet');
    }
  },

  setUserSettings: (config, userSettings) => {
    DataBus.haveUserSettings = true;
    DataBus.userSettings = userSettings; 
    //console.log('DataBus.userSettings', userSettings); 

    if (DataBus.dataEvents.setUserSettings) {
      DataBus.dataEvents.setUserSettings(config, userSettings); 
    }
  }, 
}


export default DataBus;
